import React from 'react';

interface ProgressBarProps {
  percent: number;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percent, className = '' }) => {
  const clamped = Math.min(100, Math.max(0, percent));
  return (
    <div className={`h-1.5 w-full rounded-full bg-neutral-200 dark:bg-neutral-700 overflow-hidden ${className}`}>
      <div
        className="h-full rounded-full bg-primary-500 transition-all duration-300"
        style={{ width: `${clamped}%` }}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  );
};

export default ProgressBar;
